<template>
  <div class="about">
    <div id="twitch-embed"></div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            actionName:'',
            videoId:'',
            wsUrl:'ws://182.92.84.103:7397'
        }
    },
    mounted() {
        // this.initWebSocket()
    },
    methods: {
        initWebSocket(){ //初始化weosocket
            console.log(111);
            const wsUrl = this.wsUrl;
            this.websock = new WebSocket(wsUrl);
            this.websock.onmessage = this.websocketonmessage;
            this.websock.onopen = this.websocketonopen;
            this.websock.onerror = this.websocketonerror;
            this.websock.onclose = this.websocketclose;
        },
        websocketonopen(){ //ws连接建立回调
            console.log('连上了');
            clearInterval(this.timer)
            this.lockReconnect = false
            this.loginWs = true 
            this._heartCheck()
            let obj = {
                "type":'online_request',
                "token":'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsInVzZXJJZCI6IlUxNDc1NDY4MjQxMDMyMjEyNDgwIn0.COQ41nltwKE9RiYEi65vrDuWFLsZFC2M6CmHyrjoQYA'
            }
            this.websocketsend(JSON.stringify(obj))
        },
        _heartCheck() { // 心跳
            this.pingInterval = setInterval(() => {
                if(this.websock.readyState === 1) {
                    let obj = {
                        "type":'online_request',
                        "token":'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dpblR5cGUiOiJsb2dpbiIsInVzZXJJZCI6IlUxNDc1NDY4MjQxMDMyMjEyNDgwIn0.COQ41nltwKE9RiYEi65vrDuWFLsZFC2M6CmHyrjoQYA'
                    }
                    this.websocketsend(JSON.stringify(obj))
                }
            },30000)
        },
        websocketonerror(){ //ws连接建立失败重连
            if(this.lockReconnect) return
            this.lockReconnect = true
            this.timer = setInterval(() => {
                this.initWebSocket();   
                this.lockReconnect = false
            }, 10000); 
        },
        websocketonmessage(e){ //ws来消息了
            console.log(e.data);
            if(e.data){
                if(!Utils.isJSON(e.data)) return
                let data = JSON.parse(e.data)
            }
        },
        websocketsend(Data){//ws数据发送
            this.websock.send(Data);
        },
        websocketclose(e){ // 关闭
            clearInterval(this.pingInterval)
            clearInterval(this.timer)
            this.lockReconnect = false
            if(this.status!='close'){ // 断开，重连
                this.initWebSocket()
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/demo.vue